<p-accordion [activeIndex]="0">
    <p-accordionTab *ngFor="let record of change_request_history_response; let i = index">
        <ng-template pTemplate="header">
            <div class="flex justify-content-between align-items-center w-full">
                <span>Change Request #{{ i + 1 }}</span>
                <span>{{ record.creation | date:'dd-MM-yyyy' }}</span>
            </div>
        </ng-template>
        <div class="overflow-hidden">
            <p-table [value]="getFilteredDetails(record.highlights_detail)" styleClass="p-datatable-gridlines"
                [tableStyle]="{ 'min-width': '50rem' }" [scrollable]="true" scrollHeight="400px">
                <ng-template pTemplate="header">
                    <tr>
                        <th style="text-align: center; width: 33%">Field</th>
                        <th style="text-align: center; width: 33%">Old Detail</th>
                        <th style="text-align: center; width: 33%">New Detail</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-detail>
                    <tr>
                        <td style="vertical-align: top;">{{ getShortKey(detail.key) }}</td>
                        <td style="vertical-align: top;">{{ detail.oldValue  }}</td>
                        <td style="vertical-align: top;">{{ detail.newValue  }}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="3" style="text-align: center;">No changes found</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </p-accordionTab>
</p-accordion>

<div *ngIf="change_request_history_response.length === 0" class="flex align-items-center justify-content-center"
    style="min-height: 300px;">
    <p-card styleClass="text-center" [style]="{ width: '360px' }">
        <ng-template pTemplate="header">
            <i class="pi pi-info-circle" style="font-size: 2rem; color: var(--primary-color); margin: 1rem;"></i>
        </ng-template>
        <h3>No Records Found</h3>
        <p>There are no change request records available.</p>
    </p-card>
</div>